import AppModal from "@/components/AppModal";
import CountDown from "@/components/Countdown";
import AppLoadingButton from "@/components/mui/LoadingButton";
import API from "@/constant/API";
import axiosInstance from "@/utils/axios";
import { Button, Stack, Box} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Security2FA from "../security/Security2FA";
import { setTaskRuleParams } from "@/redux/slices/user";
import { VerifyAction } from "@/constant/VerifyConstant";
import useToggle from "@/hook/useToggle";
import RpIcon from "@/components/RpIcon";
import CountdownV2 from "@/components/CountdownV2";
import classes from "./index.module.less";

function CheckoutCounter({ open, onClose, paymentOrder, onSuccess }) {
  const {t} = useTranslation();
  const [payOrder, setPayOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [orderTimeout, setOrderTimeout] = useState(false);
  const [integerPart, decimalPart] = payOrder?.payOrder?.payTotalAmount?.toString().split('.') || ['0', '00'];

  const {
    toggle: show2FA,
    onToggle: toggleShow2FA,
  } = useToggle(false);

  useEffect(() => {
    if (open) {
      _initPaymentOrder();
    }
  }, [open]);

  const _initPaymentOrder = async () => {
    if (!paymentOrder) return;
    const res = await axiosInstance.post(API.PAYMENT_ORDER, {
      bizSn: paymentOrder.sn
    });

    setPayOrder(res);
  }

  const _onPayment = async () => {
    if (!payOrder.sufficient) {
      // todo: 充值引导
    }


    // 是否需要2fa
    if (payOrder.auth2Fa) {
      setTaskRuleParams({
        action: VerifyAction.PAYMENT,
      });
      toggleShow2FA();
    } else {
      _doPayment();
    }
  }

  const _on2FAVerify = () => {
    _doPayment();
  }

  const _doPayment = async () => {
    setLoading(true);
    try {
      await axiosInstance.post(API.PAYMENT_SUBMIT, {
        sn: payOrder.payOrder.sn,
      });
      onSuccess?.();
    } finally {
      setLoading(false);
    }
  }

  const _onPriceTimeout = () => {
    _initPaymentOrder();
  }

  const _onOrderTimeout = () => {
    setOrderTimeout(true);
    // Order timeout will can not do payment anymore
  }

  const _priceRefresh = () => {
    if (!payOrder.payOrder.showPriceExpire) return null;

    return <CountdownV2 seconds={payOrder.payOrder.priceExpire} onEnd={_onPriceTimeout} />;
  }

  const _currencyItem = (item, isSupport) => {
    return <Stack direction={'column'} gap={'8px'} sx={{marginBottom:'16px'}}>
      <Stack direction={'row'} justifyContent={'space-between'}  className={classes['list-wrap']}>
        <Stack direction={'row'} className={'h5'}>
          <RpIcon icon="" />
          {item.payVarietyCode?.toUpperCase()}
        </Stack>
        {isSupport && <Stack>
          <div className={'h5'}>{item.payAmount}</div>
          <div className={'small'}>≈{item.bizAmount} {item.bizVarietyCode}</div>
        </Stack>}
      </Stack>
    </Stack>
  }

  const _supportCurrencyList = () => {
    const supportList = payOrder.assets.filter(item => item.allowedPay) ?? [];

    return supportList.map((item, idx) => <Fragment key={idx}>
      {_currencyItem(item, true)}
    </Fragment>);
  }

  const _unSupportCurrencyList = () => {
    const unSupportList = payOrder.assets.filter(item => !item.allowedPay) ?? [];
    
    return unSupportList.map((item, idx) => <Fragment key={idx}>
      {_currencyItem(item, false)}
    </Fragment>);
  }

  if (!payOrder) return null;

  const showTimeout = payOrder.payOrder.showTimeExpire && payOrder.payOrder.sufficient;

  if (orderTimeout) {
    return <>{t('order_timeout')}</>
  }

  return (
    <AppModal open={open} onClose={onClose}>
      <Stack direction="row" alignItems="center" className={'container-wrap'}>
        <Box flexShrink={0} onClick={onClose}>
          <RpIcon icon={'close'} size={18} />
        </Box>
        <Box flexGrow={1} textAlign="center" className={'h6'}>
          {t('payment')}
        </Box>
        <Box flexShrink={0} width={16} />
      </Stack>
      <Stack className={'container-wrap'}>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <div>
            <span className={'h1'}>{integerPart}</span>{decimalPart && <span className={'h3'}>.{decimalPart}</span>} <span className={'h3'}>{payOrder.payOrder.showPayVarietyCode}</span>
          </div>
          <img src="/images/guide-Illustration.svg" alt=""/>
        </Stack>


        {showTimeout && <CountdownV2 seconds={payOrder.payOrder.timeExpire} onEnd={_onOrderTimeout} />}

        {_priceRefresh()}

        {_supportCurrencyList()}
        {_unSupportCurrencyList()}

        {payOrder.payOrder.sufficient == false && <div>{t('insufficient_balance')}</div>}

        {payOrder.payOrder.sufficient ? <AppLoadingButton size="large" variant="contained" fullWidth loading={loading} onClick={_onPayment}>
          {t('confirm')}
        </AppLoadingButton> : <AppLoadingButton size="large" variant="contained" fullWidth onClick={_onPayment}>
          {t('deposit')}
        </AppLoadingButton>}
      </Stack>

      <AppModal open={show2FA} onClose={toggleShow2FA}>
        <Security2FA callback={_on2FAVerify} onClose={toggleShow2FA}/>
      </AppModal>
    </AppModal>
  );
}

export default CheckoutCounter;
